import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectNewModule,
  tryCreateModule,
} from "../../../store/slices/back-course";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import ModalMessages from "../../layout/modal-messages";
import BackCoursesModulesDrawerSkeleton from "../skeleton/drawerSkeleton";
import { useFormik } from "formik";

const validate = (values) => {
  const errors = {};

  if (!values.title || values.title === "") errors.title = "Requerido";
  if (!values.description || values.description === "")
    errors.description = "Requerido";

  return errors;
};
const ModulesDrawer = ({
  openDrawer,
  setOpenDrawer,
  moduleId,
  moduleTitle,
  moduleDescription,
  courseId,
  openDialog,
  setOpenDialog,
}) => {
  const dispatch = useDispatch();

  //Trae el detalle de un modulo nuevo
  const newModule = useSelector(selectNewModule);

  //Creo el formik
  const formik = useFormik({
    eneableReinitialize: true,
    initialValues: {
      courseModuleId: "",
      courseId: "",
      title: "",
      description: "",
    },
    validate,
    onSubmit: async () => {
      const action = await dispatch(tryCreateModule(formik.values));
      if (action.payload.data.isValid) {
        setOpenDrawer(false);
        setOpenDialog(true);
      }
    },
  });

  //Actualizo el formik
  useEffect(() => {
    formik.setValues({
      courseModuleId: moduleId,
      courseId: courseId,
      title: moduleTitle,
      description: moduleDescription,
    });
  }, [openDrawer]);

  return (
    <>
      <Drawer
        anchor="right"
        open={openDrawer}
        PaperProps={{
          sx: { zIndex: 1203, width: 500, boxSizing: "border-box" },
        }}
        onClose={() => setOpenDrawer(false)}
        sx={{
          zIndex: 1203,
          width: 500,
          flexShrink: 0,
        }}
      >
        <Grid container p={1}>
          <Grid item xs={10}>
            <Typography
              variant="h4"
              align="left"
              sx={{
                paddingLeft: 1,
                paddingRight: 5,
                paddingBottom: 1,
                paddingTop: 4,
                fontWeight: "bold",
                fontSize: 20,
              }}
            >
              Contenidos/Módulos
            </Typography>
            <Typography
              sx={{
                paddingLeft: 1,
                paddingRight: 5,
                paddingBottom: 3,
                paddingTop: 1,
              }}
            >
              Por favor, complete información del campo requerido
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ textAlign: "end" }}>
            <IconButton
              sx={{ color: "white" }}
              onClick={() => setOpenDrawer(false)}
            >
              <GridCloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        {newModule.isLoading ? (
          <BackCoursesModulesDrawerSkeleton />
        ) : (
          <Grid
            container
            rowSpacing={3}
            spacing={3}
            paddingTop={6}
            paddingLeft={4}
            paddingRight={4}
            paddingBottom={6}
            sx={{ backgroundColor: "white" }}
          >
            <Grid item xs={12}>
              <TextField
                id="title"
                label="Titulo"
                value={formik.values.title}
                onChange={formik.handleChange}
                multiline
                autoSize
                rows={1}
                variant="outlined"
                sx={{ width: "100%" }}
                error={formik.touched.title && formik.errors.title}
                helperText={formik.touched.title && formik.errors.title}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="description"
                label="Descripción"
                value={formik.values.description}
                onChange={formik.handleChange}
                multiline
                autoSize
                rows={20}
                variant="outlined"
                sx={{ width: "100%" }}
                error={formik.touched.description && formik.errors.description}
                helperText={
                  formik.touched.description && formik.errors.description
                }
              />
            </Grid>

            <Grid item xs={6} align="right" marginTop={3}>
              <Button variant="contained" onClick={() => formik.handleSubmit()}>
                GUARDAR
              </Button>
            </Grid>
            <Grid item xs={6} marginTop={3}>
              <Button
                variant="outlined"
                color="error"
                onClick={() => setOpenDrawer(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        )}
        {newModule.errors && newModule.errors.length > 0 && (
          <ModalMessages errors={newModule.errors} />
        )}
      </Drawer>
      {openDialog && (
        <>
          <Dialog
            open={openDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"La información ha sido guardada con éxito"}
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)} autoFocus>
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>{" "}
        </>
      )}
    </>
  );
};

export default ModulesDrawer;
